import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	padding: 0 30px 20px 0;
	border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

const StyledRightContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;
`;

const StyledTitle = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;

	img {
		width: 30px;
		height: 30px;
	}

	${Text} {
		font-weight: 700;
		font-size: 18px;
		color: #ffffff;
	}
`;

const StyledLevelContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	height: 30px;
	padding: 0 10px;
	background-color: #fabe2c;
	border-radius: 10px;

	img {
		width: 10px;
		height: 10px;
		user-select: none;
		pointer-events: none;
		filter: invert(1);
	}

	${Text} {
		font-weight: 500;
		font-size: 14px;
		color: #000000;
	}
`;

export {
	StyledContainer,
	StyledLevelContainer,
	StyledRightContainer,
	StyledTitle,
};
